import {JackpotWidgetDefaultBox} from './jackpot-widget-wrapper.default.box';

export const JackpotWidgetWrapperBox = JackpotWidgetDefaultBox;
